import { createReducer } from "typesafe-actions";

import DrillDownViewState from "@app/scene/dashboard/types/DrillDownViewState";
import AverageStopsPerRouteCardConfiguration from "@app/types/dashboard/cards/averageStopsPerRoute/AverageStopsPerRouteCardConfiguration";
import { DEFAULT_PAGE_SIZE } from "@app/util/consts";
import { createEmptyFilterModel } from "@app/util/filters/utils";

import {
  applyAverageStopsPerRouteDrillDownListViewSettings,
  AverageStopsPerRouteCardActions,
  fetchAverageStopsPerRouteCardDrillDownData,
  hideAverageStopsPerRouteDrillDown,
  showAverageStopsPerRouteDrillDown,
} from "./actions";

export interface AverageStopsPerRouteCardState {
  configuration?: AverageStopsPerRouteCardConfiguration; // also works as a "visible" trigger, visible if set
  loading?: boolean;
  totalFilteredRoutes: number;
  totalRoutes: number;
  viewState: DrillDownViewState;
}

export const averageStopsPerRouteInitialState: AverageStopsPerRouteCardState = {
  totalFilteredRoutes: 0,
  totalRoutes: 0,
  viewState: {
    columns: [],
    filter: createEmptyFilterModel(),
    range: { endRow: DEFAULT_PAGE_SIZE, startRow: 0 },
    sort: [],
  },
};

const averageStopsPerRouteState = createReducer<
  AverageStopsPerRouteCardState,
  AverageStopsPerRouteCardActions
>(averageStopsPerRouteInitialState)
  .handleAction(showAverageStopsPerRouteDrillDown.request, (state, { payload }) => ({
    ...state,
    configuration: payload.configuration,
  }))
  .handleAction(showAverageStopsPerRouteDrillDown.success, (state, { payload }) => ({
    ...state,
    viewState: payload.viewState,
  }))
  .handleAction(hideAverageStopsPerRouteDrillDown, (state) => ({
    ...state,
    configuration: undefined,
  }))
  .handleAction(fetchAverageStopsPerRouteCardDrillDownData.request, (state) => ({
    ...state,
    loading: true,
  }))
  .handleAction(fetchAverageStopsPerRouteCardDrillDownData.success, (state, { payload }) => ({
    ...state,
    loading: false,
    totalFilteredRoutes: payload.totalFilteredRoutes,
    totalRoutes: payload.totalRoutes,
  }))
  .handleAction(fetchAverageStopsPerRouteCardDrillDownData.failure, (state) => ({
    ...state,
    loading: false,
  }))
  .handleAction(applyAverageStopsPerRouteDrillDownListViewSettings, (state, { payload }) => ({
    ...state,
    viewState: {
      ...state.viewState,
      columns: payload.columns ?? state.viewState.columns,
      filter: payload.filter ?? state.viewState.filter,
      range: payload.range ?? state.viewState.range,
      sort: payload.sort ?? state.viewState.sort,
    },
  }));

export default averageStopsPerRouteState;
